import React from 'react';
import { Autocomplete, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import { Nullable } from 'global';
import { DealBuilderContact } from '../../../types';
import { getContactId } from '../../../lib';

interface Props {
  options: DealBuilderContact[];
  accountName: Nullable<string>;
  onSelect: (contact: DealBuilderContact) => void;
}

export const ContactSearchAutocomplete = ({ options, accountName, onSelect }: Props) => (
  <Autocomplete
    fullWidth
    options={options}
    getOptionLabel={({ fullName }) => fullName}
    filterOptions={(opts, { inputValue }) => {
      const q = inputValue.toLowerCase();
      return opts.filter(
        c => c.fullName.toLowerCase().includes(q) || c.email?.toLowerCase().includes(q) || c.phone?.includes(q)
      );
    }}
    onChange={(_, value) => {
      if (value) onSelect(value);
    }}
    value={null}
    blurOnSelect
    clearOnBlur
    renderOption={(props, contact) => (
      <li {...props} key={getContactId(contact)}>
        <Stack flex={1}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2">
              {[contact.fullName, contact.phone, contact.email].filter(Boolean).join(' \u2022 ')}
            </Typography>
            {contact.title && (
              <Typography variant="body2" color="text.secondary" sx={{ ml: 2, flexShrink: 0 }}>
                {contact.title}
              </Typography>
            )}
          </Stack>
          {accountName && (
            <Typography variant="caption" color="text.secondary">
              {accountName}
            </Typography>
          )}
        </Stack>
      </li>
    )}
    renderInput={params => (
      <TextField
        {...params}
        variant="outlined"
        size="small"
        placeholder="Search existing contacts"
        InputProps={{
          ...params.InputProps,
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    )}
  />
);
